import { Button, OverlayTrigger, Tooltip, ListGroup } from "react-bootstrap";
import { React, useState, useEffect } from 'react'
import { ApiManager } from "../../ApiManager"
import { handleApiError } from "../../utils/apiErrorHandler";
import ConfirmationModal from '../Modals/ConfirmationModal';
import StrategyModal from "../Modals/StrategyModal";
import ProjectStrategyEvaluationModal from '../Modals/ProjectStrategyEvaluationModal';
import PencilIcon from '../../Assets/Images/pencil-square.svg'
import TrashIcon from '../../Assets/Images/trash.svg'


const Strategies = (props) => {
    const project = props.project;
    const chapter = props.chapter;
    const strategy = props.strategy;
    const editingProject = props.editingProject
    const IsEditingSection = props.IsEditingSection
    const setReloadChapter = props.setReloadChapter;

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [enableStrategyHandler, setEnableStrategyHandler] = useState(false);
    const [showStrategyModal, setShowStrategyModal] = useState(false);
    const [showEvaluationModal, setShowEvaluationModal] = useState(false);

    //const cursorStyle = editingProject && !canEditSections ? "pointer" : "auto";

    useEffect(() => {
        if (enableStrategyHandler) {
            const updatedStrategy = { ...strategy, Enabled: !strategy.Enabled };
            const apiCall = editingProject
                ? ApiManager.getInstance().deleteProjectStrategy(updatedStrategy)
                : ApiManager.getInstance().deleteStrategy(updatedStrategy);
            apiCall.then(() => {
                setReloadChapter(true);
            }).catch(handleApiError).finally(() => {
                setEnableStrategyHandler(false);
            });
        }
    }, [enableStrategyHandler]); // eslint-disable-line react-hooks/exhaustive-deps

    const strategyClicked = () => {
        if (editingProject && !IsEditingSection)
            setShowEvaluationModal(true);
    }

    return (
        <>
            <ProjectStrategyEvaluationModal
                chapter={chapter}
                project={project}
                strategy={strategy}
                showEvaluationModal={showEvaluationModal}
                setShowEvaluationModal={setShowEvaluationModal}
                setReloadChapter={setReloadChapter}
            />
            <StrategyModal
                editingProject={editingProject}
                strategy={strategy}
                createOrUpdate={2}
                chapter={chapter}
                showStrategyModal={showStrategyModal}
                setShowStrategyModal={setShowStrategyModal}
                setReloadChapter={setReloadChapter} />
            <ConfirmationModal
                type="strategy"
                setYesHandler={setEnableStrategyHandler}
                showConfirmationModal={showConfirmationModal}
                setShowConfirmationModal={setShowConfirmationModal}
                Name={strategy.Description} />
            {
                strategy.Enabled &&
                <ListGroup.Item onClick={() => strategyClicked()} style={{
                    backgroundColor: strategy.LastModified === null ? "#FFE55E" : "",
                    borderLeft: strategy.IsPrerequisite ? "4px solid var(--pc-red)" : ""
                }}>
                    <div key={strategy.Id} className="d-flex m-1">
                        {/* flex:1 + minWidth:0 rather than a fixed width:85% — the old value plus
                            the edit/delete toolbar could exceed 100% of the row, and it did not
                            shrink, so the description forced the row wider than its container */}
                        <div style={{ flex: 1, minWidth: 0, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", cursor: "auto" }}>
                            {strategy.IsPrerequisite && <span className="badge me-2" style={{ backgroundColor: "var(--pc-red)", color: "white" }}>Prerequisite</span>}
                            {strategy.AgreedUpon && <span className="me-1" style={{ color: "var(--pc-yellow)" }} title="Agreed Upon Strategy">★</span>}
                            {strategy.Description}
                        </div>
                        {IsEditingSection &&
                            <div className="ms-auto">
                                <OverlayTrigger placement="top" overlay={<Tooltip id={"tooltip-sections"}>Edit Strategy</Tooltip>}>
                                    <Button className="icon-btn" onClick={() => setShowStrategyModal(true)} ><img src={PencilIcon} alt="Pencil Icon" /></Button>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={<Tooltip id={"tooltip-sections"}>Remove Strategy</Tooltip>}>
                                    <Button className="icon-btn" onClick={() => setShowConfirmationModal(true)}><img src={TrashIcon} alt="Trash Icon" /></Button>
                                </OverlayTrigger>
                            </div>
                        }
                    </div>
                </ListGroup.Item>
            }
        </>
    )
};

export default Strategies;